export default "<p>\n    {{ 'MODULE_UNDER_CONSTRUCTION' | translate }}\n</p>\n"